import { message, Modal, Skeleton, Tooltip } from "antd";
import { Table } from "antd";
import { Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import { errorMessage } from "../../utils/notificationUtils";
import {
  getReferralChecklist,
  postFOReferralChecklist,
  postMOReferralChecklist,
} from "../../apis/patientService";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import NewConfirmationModal from "./NewConfirmationModal";

type ReferralCheckListModalProps = {
  visible: any;
  handleCancel: any;
  referralId: any;
  documentId: any;
};

const ReferralChecklistModal: React.FC<ReferralCheckListModalProps> = ({
  visible,
  handleCancel,
  referralId,
  documentId,
}) => {
  const { auth, patients } = useSelector((state: RootState) => state);
  const [isFetchingReferralChecklistData, setIsFetchingReferralChecklistData] =
    useState<any>();
  const [referralChecklistData, setReferralChecklistData] = useState<any>();
  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const [pendingAction, setPendingAction] = useState<{
    id: string;
    field: "uploadStatus" | "verificationStatus";
    e: any;
  } | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleCheckboxClick = (
    id: string,
    field: "uploadStatus" | "verificationStatus",
    e: any
  ) => {
    setPendingAction({ id, field, e });
    setConfirmModal(true);
  };

  const handleConfirmSave = async () => {
    if (!pendingAction) return;
    const { id, field, e } = pendingAction;
    setConfirmModal(false);
    setPendingAction(null);
    const newValue = e.target.checked;
    try {
      let res;
      setIsSubmitting(true);
      if (field === "uploadStatus") {
        res = await postFOReferralChecklist(id);
      } else if (field === "verificationStatus") {
        res = await postMOReferralChecklist(id);
      }
      if (res) {
        await fetchReferralChecklistDetail();
        message.success("Status updated successfully");
      }
      setIsSubmitting(false);
    } catch (error) {
      message.error("Error occurred while updating status");
      setIsSubmitting(false);
    }
  };

  // const handleCheckboxChange = async (
  //   id: string, //particular procedure id needs to be send
  //   field: "uploadStatus" | "verificationStatus",
  //   e: any
  // ) => {
  //   const newValue = e.target.checked;
  //   try {
  //     // const res = await updateStatus(id, field, newValue);
  //     let res;

  //     if (field === "uploadStatus") {
  //       res = await postFOReferralChecklist(id);
  //     } else if (field === "verificationStatus") {
  //       res = await postMOReferralChecklist(id);
  //     }
  //     if (res) {
  //       await fetchReferralChecklistDetail();
  //       // setData((prev) =>
  //       //   prev.map((item) =>
  //       //     item.key === id ? { ...item, [field]: newValue } : item
  //       //   )
  //       // );
  //       message.success("Status updated successfully");
  //     }
  //   } catch (error) {
  //     message.error("Error occurred while updating status");
  //   }
  // };

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "srNo",
      key: "srNo",
      render: (_: boolean, record: any, index: any) => (
        index+1
      ),
    },
    {
      title: "Referral Item Name",
      dataIndex: "serviceName",
      key: "serviceName",
      render: (_: boolean, record: any) => (
        <Tooltip title={record?.serviceName}>
          <span>
            {record?.serviceName?.length > 64
              ? record?.serviceName.substring(0, 64) + "..."
              : record?.serviceName}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Upload Status Check",
      dataIndex: "uploadStatus",
      key: "uploadStatus",
      // render: (value: boolean) => (
      //   <Checkbox
      //     checked={value}
      //     disabled={auth?.role?.role === "BO_STAFF" ? true : false}
      //   />
      // ),
      render: (_: boolean, record: any) => (
        <Checkbox
          className="custom-blue-checkbox"
          checked={record.foChecked}
          disabled={!(auth?.role?.role === "FO_STAFF") || record?.foChecked}
          onChange={(e) => handleCheckboxClick(record.id, "uploadStatus", e)}
        />
      ),
    },
    {
      title: "Verification Status Check",
      dataIndex: "verificationStatus",
      key: "verificationStatus",
      // render: (value: boolean) => (
      //   <Checkbox
      //     checked={value}
      //     disabled={auth?.role?.role === "FO_STAFF" ? true : false}
      //   />
      // ),
      render: (_: boolean, record: any) => (
        <Checkbox
          className="custom-blue-checkbox"
          checked={record.amoChecked}
          disabled={auth?.role?.role === "FO_STAFF" || record?.amoChecked}
          onChange={(e) =>
            handleCheckboxClick(record.id, "verificationStatus", e)
          }
        />
      ),
    },
  ];

  const fetchReferralChecklistDetail = async () => {
    try {
      setIsFetchingReferralChecklistData(true);
      const res = await getReferralChecklist(patients?.fetchBasicDetails?.casesResponse?.id, patients?.fetchBasicDetails?.visitInfoResponse?.id);
      setReferralChecklistData(res);
      setIsFetchingReferralChecklistData(false);
    } catch (err) {
      errorMessage("Please, Try again later");
      setIsFetchingReferralChecklistData(false);
    }
  };

  useEffect(() => {
    if (visible && referralId) {
      fetchReferralChecklistDetail();
    }
  }, [visible, referralId]);

  return (
    <>
      <Modal
        title="Referral Checklist"
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        width={4000}
      >
        {isFetchingReferralChecklistData ? (
          <Skeleton />
        ) : (
          <Table
            columns={columns}
            dataSource={referralChecklistData}
            pagination={false}
            className="referral-checklist-table"
            rowClassName={(_, index) =>
              index % 2 === 0 ? "referral-checklist-row-alt" : ""
            }
          />
        )}
      </Modal>

      <NewConfirmationModal
        open={confirmModal}
        title={"Are you sure you want to update the status for this checklist item?"}
        handleCancel={() => setConfirmModal(false)}
        handleSave={handleConfirmSave}
        isLoading={isSubmitting}
      />
    </>
  );
};

export default ReferralChecklistModal;
